import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Landing from "../pages/Landing";

export function FullPageSpinner() {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading…</span>
      </div>
    </div>
  );
}

export function RequireAuth({ children }) {
  const { user, checking, signedOut } = useAuth();
  const location = useLocation();
  if (checking) return <FullPageSpinner />;
  if (!user) {
    if (location.pathname === "/") return <Landing />;
    const from = signedOut ? undefined : { from: location.pathname + location.search };
    return <Navigate to="/login" replace state={from} />;
  }
  return children;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user?.role === "superadmin") return <Navigate to="/superadmin" replace />;
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

export function RequireSuperAdmin({ children }) {
  const { user } = useAuth();
  if (user?.role !== "superadmin") return <Navigate to="/" replace />;
  return children;
}

/** Superadmins only maintain the app — keep them on the ops console (and profile). */
export function SuperAdminGate({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user?.role !== "superadmin") return children;
  const path = location.pathname;
  if (path === "/superadmin" || path.startsWith("/superadmin/") || path === "/profile") return children;
  return <Navigate to="/superadmin" replace />;
}

export function PublicOnly({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) return <FullPageSpinner />;
  if (user) {
    const fallback = user.role === "superadmin" ? "/superadmin" : "/";
    return <Navigate to={location.state?.from || fallback} replace />;
  }
  return children;
}
